import {useMemo} from 'react';
import {FilterProps} from '../filter-types';
import {NetworkOptimizationStore} from './types';

export function useAdequacyStandardFilter(
    noStore: NetworkOptimizationStore,
    loadingGeographyData: boolean,
    onChange: (value: string) => void
): FilterProps {
    return useMemo(() => {
        const data = noStore.getGeoFilterUniqueValuesByKey('GEOGRAPHY', 'standard_type');

        return {
            label: 'Adequacy Standard',
            data,
            value: noStore.appliedGeographyFilter.standard_type,
            required: true,
            onChange,
            children: [
                (item: any): string => item,
                (item: any) => item,
            ],
            spinner: loadingGeographyData,
            ['data-testid']: 'adequacy-standard-dropdown',
        };
    }, [noStore, loadingGeographyData, onChange, noStore.appliedGeographyFilter.standard_type]);
}
